"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var react_1 = __importDefault(require("react"));
var Collection_1 = __importDefault(require("./Collection"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var MobileGamesVertical = function (_a) {
    var _b;
    var preparedCollections = _a.preparedCollections;
    var t = (0, next_intl_1.useTranslations)('translation');
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.wrapper },
        react_1.default.createElement(ui_components_1.TopBar, { title: t('live'), showNavigationButtons: false, linkAddress: null, titlePosition: "center" }),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.slide }, (_b = preparedCollections === null || preparedCollections === void 0 ? void 0 : preparedCollections.slice(0, 8)) === null || _b === void 0 ? void 0 : _b.map(function (item, idx) { return (react_1.default.createElement(Collection_1.default, __assign({ key: "gamesSetCollectionsMobile".concat(idx) }, item))); })))));
};
exports.default = MobileGamesVertical;
